import { render } from "./PlaygroundContextMenu.vue?vue&type=template&id=0c3ce12c&scoped=true"
import script from "./PlaygroundContextMenu.vue?vue&type=script&lang=js"
export * from "./PlaygroundContextMenu.vue?vue&type=script&lang=js"

import "./PlaygroundContextMenu.vue?vue&type=style&index=0&id=0c3ce12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3ce12c"]])

export default __exports__